<template>
  <div class="edit-balance">
    <div @click="onClick">
      修改积分
    </div>
    <a-modal
      :title="'修改积分：' + balance"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      :closable="false"
      :centered="true"
      cancelText="取消"
      okText="确定"
      width="40%"
    >
      <a-radio-group v-model="radioValue">
        <a-radio :disabled="this.vip === 2" style="display: block" value="1">
          按群计算
        </a-radio>
        <div style="margin: 5px 0 5px 50px;">
          <label class="info" style="width: 30%">数量</label>
          <a-input v-model="count" style="width: 150px" :disabled="radioValue !== '1'" ></a-input>
        </div>
        <div style="margin: 5px 0 5px 50px;">
          <label class="info" style="width: 30%">APP </label>
          <a-select :disabled="true" v-model="app" style="width: 150px">
            <a-select-option value="zidou"> 紫豆助手 </a-select-option>
            <a-select-option value="yaca"> 友问币答 </a-select-option>
          </a-select>
        </div>
        <div style="margin: 5px 0 5px 50px;">
          <label class="info" style="width: 30%">类型</label>
          <a-select :disabled="true" v-model="vip" style="width: 150px">
            <a-select-option value="0"> 普通用户 </a-select-option>
            <a-select-option value="1"> VIP 用户 </a-select-option>
          </a-select>
        </div>
        <a-radio style="display: block; margin-top: 20px" value="2">
          手动输入
          <a-input-number v-model="custom" style="width: 100px; margin-left: 7px" :disabled="radioValue !== '2'" ></a-input-number>
          <a-select v-model="custom_type" style="width: 100px; margin: 0 10px;">
            <a-select-option value="5"> 免费 </a-select-option>
            <a-select-option value="13"> 个人充值 </a-select-option>
            <a-select-option value="14"> 企业充值 </a-select-option>
          </a-select>
          <span v-show="custom_type === '13' || custom_type === '14'">
            <a-input-number v-model="price"></a-input-number>
            <span>元</span>
          </span>
        </a-radio>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import AModal from 'ant-design-vue/es/modal/Modal'
const axios = require('axios')
export default {
  name: 'EditBalance',
  components: {AModal},
  props: ['record', 'priceList', 'dataIndex'],
  data () {
    return {
      editBalanceUrlPostFix: 'UBalance/edit_balance',
      visible: false,
      confirmLoading: false,
      radioValue: this.vip < 2 ? '1' : '2',
      count: 1,
      custom: 0,
      custom_type: '',
      price: ''
    }
  },
  computed: {
    app: function () {
      console.log(this.record)
      if (this.record.app === 'test') {
        return 'yaca'
      }
      return this.record.app
    },
    vip: function () {
      console.log(this.record)
      return this.record.vip
    },
    editBalanceUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editBalanceUrlPostFix
    },
    balance: function () {
      if (this.radioValue === '2') {
        return this.custom
      } else if (this.radioValue === '1') {
        return this.priceList[this.app][parseInt(this.vip)] * this.count
      }
    }
  },
  watch: {
    count: function (newValue, oldValue) {
      // console.log('count', newValue, oldValue)
      var a = parseInt(newValue)
      // console.log('count', a)
      if (isNaN(a)) {
        a = 0
      }
      this.count = a
    }
  },
  methods: {
    onClick () {
      // console.log('onClick')
      this.visible = true
    },
    handleOk () {
      if (parseInt(this.price) < 0) {
        this.$message.error('金额不能为负')
        return
      }
      // console.log('handleOk')
      this.confirmLoading = true
      axios.post(this.editBalanceUrl, {
        client_id: this.record.client_id,
        balance: this.balance,
        custom_type: parseInt(this.custom_type),
        price: parseInt(this.price) * 100,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            // console.log('修改 balance 成功')
            this.visible = false
            this.confirmLoading = false
            this.$emit('on-balance-edit', this.dataIndex, this.balance)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    handleCancel () {
      // console.log('handleCancel')
      this.visible = false
      this.confirmLoading = false
    }
  }
}
</script>

<style scoped>

</style>
